module.exports = __webpack_public_path__ + "img/mobile-66.5d7f0b4c.png";